import vector from "@/assets/blog/vector-blue.png";
import BlogShare from "@/components/Shared/BlogShare";
import ExpandingButton from "@/components/Buttons/ExpandingButton";
import { Widget } from "@typeform/embed-react";
import localizePath from "@/functions/localizePath";
import useLocale from "@/hooks/useLocale";

export default function BlogArticleInfo({ article }) {
  const locale = useLocale();

  return (
    <div
      id="BlogArticleContent"
      className="relative pt-10 sm:pt-[90px] flex flex-col justify-center items-center sm:block"
    >
      <img
        src={vector ?? ""}
        alt="vector"
        className="absolute bottom-0 left-0"
      />
      <div className="sm:sticky top-[200px] w-max ml-4 xl:ml-[75px]">
        <BlogShare
          style={{
            title: "Share",
            color: "text-slate-gray",
            line: "bg-black-opacity",
          }}
          page="newsroom"
          url={article?.url_slug}
          content={article?.meta_description}
        />
      </div>
      <div className="sm:max-w-[82%] sm:ml-[15%] md:ml-auto lg:max-w-[836px] w-full m-auto flex flex-col gap-10 sm:gap-20 px-5 relative sm:mt-[-350px] 3xl:max-w-[80%]">
        {article?.content && (
          <div className="content text-left text-[#1B0D34]">
            <div dangerouslySetInnerHTML={{ __html: article?.content }} />
          </div>
        )}
        {article?.faqs &&
          article?.faqs?.map(({ question, answer }) => (
            <div key={question} className="text-purple flex flex-col gap-8">
              <h3 className="text-3xl sm:text-[40px]/[48px]">{question}</h3>
              <p className="whitespace-pre-line text-lg sm:text-xl/8">
                {answer}
              </p>
            </div>
          ))}
        {article?.typeform_id && (
          <Widget
            id={article.typeform_id}
            style={{
              width: "100%",
              height: 552,
              margin: "20px auto",
            }}
          />
        )}
        <div className="bg-purple px-5 py-5 sm:px-[47px] sm:py-[55px] flex justify-between items-center flex-col gap-5 md:flex-row">
          <span className="text-xl sm:text-[30px]/[40px] md:max-w-[800px] block">
            {article?.cta_title}
            <a href={`mailto:${article?.cta_email}`}>{article?.cta_email}</a>
          </span>
          <div className="py-2 px-5 text-sm sm:text-base md:text-lg lg:text-xl h-max">
            <ExpandingButton
              url={localizePath("/jobs", locale)}
              color="white"
              bgColor="transparent"
              hoverBGColor="white"
              hoverColor="purple"
            >
              Search jobs
            </ExpandingButton>
          </div>
        </div>
      </div>
    </div>
  );
}
